<div id="slide-toggle">
  <mat-slide-toggle
    #toggleRef
    color="#0099E0"
    (change)="handleToggleChange($event)"
    [checked]="isChecked"
    [disabled]="(toggleOffDisabled && toggleRef.checked) || isDisabled"
  ></mat-slide-toggle>
</div>
